import { addSentryBreadcrumb } from "../hooks/useConfigureSentry";
import { CORE_SERVICE_URL } from "@coworker/app/src/hooks/API/core.service";
import { fetchAPI } from "../hooks/API/tasks.service.helper";

export async function updateUser(uid, user) {
  if (!uid || !user) {
    addSentryBreadcrumb({
      category: "user-update",
      message: "updateUser called with empty uid or user object",
      level: "warning",
      data: { uid, user },
    });
    return;
  }
  const userCopy = { ...user, uid };
  if (userCopy.team_id) userCopy["teamId"] = userCopy.team_id;
  if (typeof userCopy.phone !== "undefined")
    userCopy["phoneNumber"] = userCopy.phone;

  const url = `${CORE_SERVICE_URL}/users/${uid}`;
  const { result } = await fetchAPI("PUT", url, userCopy);
  return result;
}
